﻿"use strict";
  var currencyConfig;
  var pb_Currency_global = window.Currency;
  var customSelector;  
  
  function loadData() {
    let selectedCookieCurrency = ((pb_Currency_global.cookie.read() != null) ? pb_Currency_global.cookie.read() : pb_defaultCurrency);
    let urlRequest = "https://currency.plusbooster.com/api/get/"+Shopify.shop+"/configuration?q="+selectedCookieCurrency;
    let xhttp = new XMLHttpRequest();
    xhttp.open("GET", urlRequest, true);
     xhttp.send();
   
     xhttp.onreadystatechange = function() {
       if (this.readyState == 4 && this.status == 200) {
         currencyConfig = JSON.parse(this.responseText);
         customSelector = currencyConfig.customSelector;
         PB_init();
       }
     };
  }
  
  function include(filename, onload) {
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.src = filename;
      script.type = 'text/javascript';
      script.onload = script.onreadystatechange = function() {
        if (script.readyState) {
          if (script.readyState === 'complete' || script.readyState === 'loaded') {
            script.onreadystatechange = null;                                                  
            onload();
          }
        } 
        else {
          onload();          
        }
      };
      head.appendChild(script);
    }    
     
  function PB_init() {
    loadNiceSelect();
    if(typeof currencyConfig != 'undefined') {
      if(currencyConfig.status = "success") {
        jQuery("span.money").each(function() {
          jQuery(this).after(`<span class="pb_currency_duplicate"></span>`);
        });
        
        let selectList = document.createElement("select");
        let wrapper = document.createElement("div");
        let selectedCurrencies = JSON.parse(currencyConfig.selectedCurrencies);
        let dropdownCurrencies = [];
        selectedCurrencies.forEach(function(e) {
          dropdownCurrencies.push(e.id);
        });
        var headerselector = jQuery(".site-header")[0] || (typeof jQuery(".site-header")[0] != 'undefined' ? jQuery("header")[0] : '');
        var selectedCurrency = currencyConfig.defaultCurrency;

        /* Cookie currency */
        var cookieCurrency = pb_Currency_global.cookie.read();
        
        if(cookieCurrency === null) {
          pb_Currency_global.cookie.write(selectedCurrency);
        }
        if(dropdownCurrencies.indexOf(cookieCurrency) === -1) {
          pb_Currency_global.cookie.write(selectedCurrency);
        }
        else {
          selectedCurrency = cookieCurrency;
        }

        pb_Currency_global.currentCurrency = selectedCurrency;

        let extraCss = "<style>.pb-nice-select-currency { background:"+currencyConfig.dropdownBgColor+"!important;color: "+currencyConfig.dropdownTextColor+"!important } .pb-nice-select-currency .list li { color: "+currencyConfig.dropdownTextColor+"!important } .pb-nice-select-currency .list li:hover { color:"+currencyConfig.dropdownHoverColor+"!important }</style>";
        jQuery("head").append(extraCss);


        wrapper.classList.add("Pb_currency_wrapper");             
        wrapper.classList.add("switcher-"+currencyConfig.switcherPosition);
        
        /** themes **/           	
        if(currencyConfig.themeSelected == 1) {
          wrapper.classList.add("Pb_currency_default_theme"); 
        }
        else if(currencyConfig.themeSelected == 2) {
          wrapper.classList.add("Pb_currency_without_flag"); 
        }
        else if(currencyConfig.themeSelected == 3) {
          wrapper.classList.add("Pb_currency_flags_16");
        }
        else if(currencyConfig.themeSelected == 4) {
          wrapper.classList.add("Pb_currency_without_flag");           		
          wrapper.classList.add("Pb_currency_compact");
        }
        else if(currencyConfig.themeSelected == 5) {
          wrapper.classList.add("Pb_currency_full_name");
        }
        else if(currencyConfig.themeSelected == 6) {
          wrapper.classList.add("Pb_currency_without_border");
        }
        /** themes **/
        
        selectList.id = "pb_currency_switcher";           	
        selectList.name = "PB_Currency_select";
        wrapper.appendChild(selectList);

        selectedCurrencies.forEach(function(e) {
          let option = document.createElement("option");
          option.value = e.id;
          option.text = ((currencyConfig.themeSelected == 5) ? e.title : e.id);
          option.setAttribute("data-display",e.id);
          selectList.appendChild(option);
        });
        
        /** if default currency is not in dropdown **/
        if(currencyConfig.defaultCurrency.indexOf(dropdownCurrencies) === -1) {
          console.log(0);
        }
        /** if default currency is not in dropdown **/
        
        if(typeof customSelector === "undefined" || customSelector === "" || customSelector === null) {
          if(currencyConfig.switcherPosition == "top-left") {
            if(typeof headerselector != "undefined") {
              jQuery(headerselector).prepend(wrapper);
            }
          }
          else if(currencyConfig.switcherPosition == "top-right") {
            if(typeof headerselector != "undefined") {
              let cartBtnSelector = find_cart_button();
              if(typeof cartBtnSelector != 'undefined') {
                for(var pi = 0; pi < cartBtnSelector.length; pi++) {
                  	let cloneWrapper = wrapper.cloneNode(true);
                  	cartBtnSelector[pi].parentNode.insertBefore(cloneWrapper, cartBtnSelector[pi].nextSibling);
                }
              }
            }
          }
          else {
            document.body.appendChild(wrapper);
          }
        }
        
        else {
          let nodeCustomSelector = document.querySelectorAll(customSelector);
          nodeCustomSelector.forEach(function(el) {
          	let cloneWrapper = wrapper.cloneNode(true);
            el.appendChild(cloneWrapper);
          });
        }

        /** change currencies  **/
        jQuery('[name=PB_Currency_select]').each(function() {
          jQuery(this).val(selectedCurrency);
        });

        jQuery('[name=PB_Currency_select]').each(function() {
          jQuery(this).niceSelect();
        });

        /* Fix for customer account pages */
        jQuery('span.money span.money').each(function() {
          jQuery(this).parents('span.money').removeClass('money');
        });
        
        hideMoreThanOne();
        
        let newCurrency = pb_Currency_global.cookie.read();
        let oldCurrency = pb_defaultCurrency;
        pb_Currency_global.convertAll(oldCurrency, newCurrency, 'span.money' , pb_Currency_global.format);
		
      }
 }
    
 function findCenter() {
   let wrapperSelector = jQuery(".Pb_currency_wrapper:visible");
     wrapperSelector.each(function() {
       let cartSelector = jQuery(this).prev('[href^="/cart"]');
       if(cartSelector != 'undefined') {
         let offsetCart = cartSelector.offset();
         if(offsetCart != undefined) {
           jQuery(this).offset({
             top: offsetCart.top
           });
         }
       }
     });	
 }

    jQuery(document).ready(function() {
      jQuery('[name=PB_Currency_select]').val(Currency.currentCurrency).change(function() {
        let newCurrency = jQuery(this).val();
        let oldCurrency = pb_Currency_global.currentCurrency;
        pb_Currency_global.convertAll(oldCurrency, newCurrency, 'span.money' , pb_Currency_global.format);
        
        //change all switchers
        jQuery('[name=PB_Currency_select]').each(function() {
        	jQuery(this).val(newCurrency);
          	jQuery(this).niceSelect('update');
        });
      });

      jQuery('body').on('ajaxCart.afterCartLoad', function(cart) {
        pbAsyncCurrency();
      });
      
      jQuery('body').on('ajaxCart.afterCartUpdate', function(cart) {
        pbAsyncCurrency();
      });
      
      /*jQuery(document).on("click", ".pb-nice-select-currency", function() {
          let container = jQuery('.list'),
              scrollTo = jQuery('.list .selected');

          container.animate({
              scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
          });
      });*/
      
      jQuery(document).ajaxComplete(function() {
        setTimeout(function() {
          pbAsyncCurrency();
        },500);
      });
      
      jQuery('.single-option-selector').bind('change.single-option-selector', function() {
        pbAsyncCurrency();
      });

      if (jQuery('.single-option-radio label').length>0) {
        jQuery('.single-option-radio label').bind('click.single-option-radio', function() {
          setTimeout(function() {
            pbAsyncCurrency();
          }, 5);
        });
        jQuery('.single-option-radio label').bind('touchend.single-option-radio', function() {
          setTimeout(function() {
            pbAsyncCurrency();
          }, 5);
        });
      }

    });
 }
  

function find_cart_button() {
  let returnSelectors = [];
  let selectors = ["header a[href='/cart']",".site_header a[href='/cart']",".header-cart-btn", ".site-header__cart", ".site_header .cart-toggle", ".cart-toggle"];
  for (var i = 0; i < selectors.length; i++) {
    var checkoutButtons = document.querySelectorAll(selectors[i]);
    for (var j = 0; j < checkoutButtons.length; j++) {
      var checkoutButton = checkoutButtons[j];
      if (checkoutButton) {
        returnSelectors.push(checkoutButton);
      }
    }
  }
  return returnSelectors;
}

  function loadNiceSelect() {
    /*jQuery Nice Select - v1.0 https://github.com/hernansartorio/jquery-nice-select Made by Hernán Sartorio  */
    !function(e){e.fn.niceSelect=function(s){function t(s){s.after(e("<div></div>").addClass("pb-nice-select-currency "+((currencyConfig.themeSelected == 3) ? 'pb-flags-16' : 'pb-flags-24')).addClass(s.attr("class")||"").addClass(s.attr("disabled")?"disabled":"").attr("tabindex",s.attr("disabled")?null:"0").html('<span class="current notranslate"></span><ul class="list"></ul>'));var t=s.next(),n=s.find("option"),a=s.find("option:selected"),c=a.attr("data-display").substring(0,2).toLowerCase();t.find(".current").html('<span class="flag '+c+'"></span> '+a.attr("data-display")),n.each(function(s){var n=e(this),a=n.data("display"),c=n.attr("data-display").substring(0,2).toLowerCase();t.find("ul").append(e("<li class='notranslate'></li>").attr("data-value",n.val()).attr("data-display",a||null).addClass("option"+(n.is(":selected")?" selected":"")+(n.is(":disabled")?" disabled":"")).html('<span class="flag '+c+'"></span> '+n.text()))})}if("string"==typeof s)return"update"==s?this.each(function(){var s=e(this),n=e(this).next(".pb-nice-select-currency"),a=n.hasClass("open");n.length&&(n.remove(),t(s),a&&s.next().trigger("click"))}):"destroy"==s?(this.each(function(){var s=e(this),t=e(this).next(".pb-nice-select-currency");t.length&&(t.remove(),s.css("display",""))}),0==e(".pb-nice-select-currency").length&&e(document).off(".nice_select")):console.log('Method "'+s+'" does not exist.'),this;this.hide(),this.each(function(){var s=e(this);s.next().hasClass("pb-nice-select-currency")||t(s)}),e(document).off(".nice_select"),e(document).on("click.nice_select",".pb-nice-select-currency",function(s){var t=e(this);e(".pb-nice-select-currency").not(t).removeClass("open"),t.toggleClass("open"),t.hasClass("open")?(t.find(".option"),t.find(".focus").removeClass("focus"),t.find(".selected").addClass("focus")):t.focus()}),e(document).on("click.nice_select",function(s){0===e(s.target).closest(".pb-nice-select-currency").length&&e(".pb-nice-select-currency").removeClass("open").find(".option")}),e(document).on("click.nice_select",".pb-nice-select-currency .option:not(.disabled)",function(s){var t=e(this),n=t.closest(".pb-nice-select-currency");n.find(".selected").removeClass("selected"),t.addClass("selected");t.data("display")||t.text();var a='<span class="flag '+t.attr("data-display").substring(0,2).toLowerCase()+'"></span>'+t.data("display")||t.text();n.find(".current").html(a),n.prev("select").val(t.data("value")).trigger("change")}),e(document).on("keydown.nice_select",".pb-nice-select-currency",function(s){var t=e(this),n=e(t.find(".focus")||t.find(".list .option.selected"));if(32==s.keyCode||13==s.keyCode)return t.hasClass("open")?n.trigger("click"):t.trigger("click"),!1;if(40==s.keyCode){if(t.hasClass("open")){var a=n.nextAll(".option:not(.disabled)").first();a.length>0&&(t.find(".focus").removeClass("focus"),a.addClass("focus"))}else t.trigger("click");return!1}if(38==s.keyCode){if(t.hasClass("open")){var c=n.prevAll(".option:not(.disabled)").first();c.length>0&&(t.find(".focus").removeClass("focus"),c.addClass("focus"))}else t.trigger("click");return!1}if(27==s.keyCode)t.hasClass("open")&&t.trigger("click");else if(9==s.keyCode&&t.hasClass("open"))return!1});var n=document.createElement("a").style;return n.cssText="pointer-events:auto","auto"!==n.pointerEvents&&e("html").addClass("no-csspointerevents"),this}}(jQuery); 
  }
  
function loadCurrencyFiles() {
    pb_Currency_global = window.Currency;
  	/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */ 

if (typeof pb_Currency_global === 'undefined') {
  var pb_Currency_global = {};
}

pb_Currency_global.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'currency',
  write: function(currency) {
    jQuery.cookie(this.name, currency, this.configuration);
  },
  read: function() {
    return jQuery.cookie(this.name);
  },
  destroy: function() {
    jQuery.cookie(this.name, null, this.configuration);
  }
};

pb_Currency_global.moneyFormats = {
	"AED": {
		"money_format": "Dhs. {{amount}}",
		"money_with_currency_format": "Dhs. {{amount}} AED"
	},
	"AFN": {
		"money_format": "Af {{amount}}",
		"money_with_currency_format": "Af {{amount}} AFN"
	},
	"ALL": {
		"money_format": "Lek {{amount}}",
		"money_with_currency_format": "Lek {{amount}} ALL"
	},
	"AMD": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} AMD"
	},
	"ANG": {
		"money_format": "ƒ{{amount}}",
		"money_with_currency_format": "{{amount}} NAƒ"
	},
	"AOA": {
		"money_format": "Kz{{amount}}",
		"money_with_currency_format": "Kz{{amount}} AOA"
	},
	"ARS": {
		"money_format": "${{amount_with_comma_separator}}",
		"money_with_currency_format": "${{amount_with_comma_separator}} ARS"
	},
	"AUD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} AUD"
	},
	"AWG": {
		"money_format": "Afl{{amount}}",
		"money_with_currency_format": "Afl{{amount}} AWG"
	},
	"AZN": {
		"money_format": "₼{{amount}}",
		"money_with_currency_format": "₼{{amount}} AZN"
	},
	"BAM": {
		"money_format": "KM {{amount_with_comma_separator}}",
		"money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
	},
	"BBD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} Bds"
	},
	"BDT": {
		"money_format": "Tk {{amount}}",
		"money_with_currency_format": "Tk {{amount}} BDT"
	},
	"BGN": {
		"money_format": "{{amount}} \u043b\u0432",
		"money_with_currency_format": "{{amount}} \u043b\u0432 BGN"
	},
	"BHD": {
		"money_format": "{{amount}} BD",
		"money_with_currency_format": "{{amount}} BHD"
	},
	"BIF": {
		"money_format": "FBu {{amount}}",
		"money_with_currency_format": "FBu {{amount}} BIF"
	},
	"BMD": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} BMD"
	},
	"BND": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} BND"
	},
	"BOB": {
		"money_format": "Bs{{amount_with_comma_separator}}",
		"money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
	},
	"BRL": {
		"money_format": "R$ {{amount_with_comma_separator}}",
		"money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
	},
	"BSD": {
		"money_format": "BS${{amount}}",
		"money_with_currency_format": "BS${{amount}} BSD"
	},
	"BTC": {
		"money_format": "{{amount_no_decimals}} BTC",
		"money_with_currency_format": "{{amount_no_decimals}} BTC"
	},
	"BTN": {
		"money_format": "Nu {{amount}}",
		"money_with_currency_format": "Nu {{amount}} BTN"
	},
	"BWP": {
		"money_format": "P{{amount}}",
		"money_with_currency_format": "P{{amount}} BWP"
	},
	"BYN": {
		"money_format": "Br {{amount}}",
		"money_with_currency_format": "Br {{amount}} BYN"
	},
	"BZD": {
		"money_format": "BZ${{amount}}",
		"money_with_currency_format": "BZ${{amount}} BZD"
	},
	"CAD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} CAD"
	},
	"CDF": {
		"money_format": "FC {{amount}}",
		"money_with_currency_format": "FC {{amount}} CDF"
	},
	"CHF": {
		"money_format": "SFr. {{amount}}",
		"money_with_currency_format": "{{amount}} CHF"
	},
	"CLP": {
		"money_format": "${{amount_no_decimals}}",
		"money_with_currency_format": "${{amount_no_decimals}} CLP"
	},
	"CNY": {
		"money_format": "¥{{amount}}",
		"money_with_currency_format": "¥{{amount}} CNY"
	},
	"COP": {
		"money_format": "${{amount_with_comma_separator}}",
		"money_with_currency_format": "${{amount_with_comma_separator}} COP"
	},
	"CRC": {
		"money_format": "₡ {{amount_with_comma_separator}}",
		"money_with_currency_format": "₡ {{amount_with_comma_separator}} CRC"
	},
	"CUC": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} CUC"
	},
	"CUP": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} CUP"
	},
	"CVE": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} CVE"
	},
	"CZK": {
		"money_format": "{{amount_with_comma_separator}} Kč",
		"money_with_currency_format": "{{amount_with_comma_separator}} Kč"
	},
	"DJF": {
		"money_format": "Fdj {{amount}}",
		"money_with_currency_format": "Fdj {{amount}} DJF"
	},
	"DKK": {
		"money_format": "kr {{amount_with_comma_separator}}",
		"money_with_currency_format": "kr {{amount_with_comma_separator}} DKK"
	},
	"DOP": {
		"money_format": "RD$ {{amount}}",
		"money_with_currency_format": "RD$ {{amount}}"
	},
	"DZD": {
		"money_format": "DA {{amount}}",
		"money_with_currency_format": "DA {{amount}} DZD"
	},
	"EGP": {
		"money_format": "LE {{amount}}",
		"money_with_currency_format": "LE {{amount}} EGP"
	},
	"ERN": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} ERN"
	},
	"ETB": {
		"money_format": "Br{{amount}}",
		"money_with_currency_format": "Br{{amount}} ETB"
	},
	"EUR": {
		"money_format": "\u20ac{{amount_with_comma_separator}}",
		"money_with_currency_format": "\u20ac{{amount_with_comma_separator}} EUR"
	},
	"FJD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "FJ${{amount}}"
	},
	"FKP": {
		"money_format": "£ {{amount}}",
		"money_with_currency_format": "£ {{amount}} FKP"
	},
	"GBP": {
		"money_format": "£{{amount}}",
		"money_with_currency_format": "£{{amount}} GBP"
	},
	"GEL": {
		"money_format": "{{amount}} GEL",
		"money_with_currency_format": "{{amount}} GEL"
	},
	"GGP": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} GGP"
	},
	"GHS": {
		"money_format": "GH₵{{amount}}",
		"money_with_currency_format": "GH₵{{amount}}"
	},
	"GIP": {
		"money_format": "£ {{amount}}",
		"money_with_currency_format": "£ {{amount}} GIP"
	},
	"GMD": {
		"money_format": "D {{amount}}",
		"money_with_currency_format": "D {{amount}} GMD"
	},
	"GNF": {
		"money_format": "FG {{amount}}",
		"money_with_currency_format": "FG {{amount}} GNF"
	},
	"GTQ": {
		"money_format": "Q{{amount}}",
		"money_with_currency_format": "{{amount}} GTQ"
	},
	"GYD": {
		"money_format": "G${{amount}}",
		"money_with_currency_format": "${{amount}} GYD"
	},
	"HKD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} HKD"
	},
	"HNL": {
		"money_format": "L {{amount}}",
		"money_with_currency_format": "L {{amount}} HNL"
	},
	"HRK": {
		"money_format": "{{amount_with_comma_separator}} kn",
		"money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
	},
	"HTG": {
		"money_format": "G {{amount}}",
		"money_with_currency_format": "G {{amount}} HTG"
	},
	"HUF": {
		"money_format": "{{amount_no_decimals_with_comma_separator}}",
		"money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
	},
	"IDR": {
		"money_format": "{{amount_with_comma_separator}} IDR",
		"money_with_currency_format": "Rp {{amount_with_comma_separator}} IDR"
	},
	"ILS": {
		"money_format": "₪{{amount}} NIS",
		"money_with_currency_format": "₪{{amount}} NIS"
	},
	"IMP": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} IMP"
	},
	"INR": {
		"money_format": "₹ {{amount}}",
		"money_with_currency_format": "₹ {{amount}} INR"
	},
	"IQD": {
		"money_format": "ع.د {{amount}}",
		"money_with_currency_format": "ع.د {{amount}} IQD"
	},
	"IRR": {
		"money_format": "﷼ {{amount}}",
		"money_with_currency_format": "﷼ {{amount}} IRR"
	},
	"ISK": {
		"money_format": "{{amount_no_decimals}} kr",
		"money_with_currency_format": "{{amount_no_decimals}} kr ISK"
	},
	"JEP": {
		"money_format": "£{{amount}}",
		"money_with_currency_format": "£{{amount}} JEP"
	},
	"JMD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} JMD"
	},
	"JOD": {
		"money_format": "{{amount}} JD",
		"money_with_currency_format": "{{amount}} JOD"
	},
	"JPY": {
		"money_format": "¥{{amount_no_decimals}}",
		"money_with_currency_format": "¥{{amount_no_decimals}} JPY"
	},
	"KES": {
		"money_format": "KSh{{amount}}",
		"money_with_currency_format": "KSh{{amount}}"
	},
	"KGS": {
		"money_format": "\u043b\u0432{{amount}}",
		"money_with_currency_format": "\u043b\u0432{{amount}}"
	},
	"KHR": {
		"money_format": "KHR{{amount}}",
		"money_with_currency_format": "KHR{{amount}}"
	},
	"KMF": {
		"money_format": "CF {{amount}}",
		"money_with_currency_format": "CF {{amount}} KMF"
	},
	"KPW": {
		"money_format": "₩ {{amount}}",
		"money_with_currency_format": "₩ {{amount}} KPW"
	},
	"KRW": {
		"money_format": "₩{{amount_no_decimals}}",
		"money_with_currency_format": "₩{{amount_no_decimals}} KRW"
	},
	"KWD": {
		"money_format": "{{amount}} KD",
		"money_with_currency_format": "{{amount}} KWD"
	},
	"KYD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} KYD"
	},
	"KZT": {
		"money_format": "{{amount}} KZT",
		"money_with_currency_format": "{{amount}} KZT"
	},
	"LAK": {
		"money_format": "₭ {{amount}}",
		"money_with_currency_format": "₭ {{amount}} LAK"
	},
	"LBP": {
		"money_format": "L.L.{{amount}}",
		"money_with_currency_format": "L.L.{{amount}} LBP"
	},
	"LKR": {
		"money_format": "Rs {{amount}}",
		"money_with_currency_format": "Rs {{amount}} LKR"
	},
	"LRD": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} LRD"
	},
	"LSL": {
		"money_format": "L {{amount}}",
		"money_with_currency_format": "L {{amount}} LSL"
	},
	"LTL": {
		"money_format": "{{amount}} Lt",
		"money_with_currency_format": "{{amount}} Lt"
	},
	"LVL": {
		"money_format": "Ls {{amount}}",
		"money_with_currency_format": "Ls {{amount}} LVL"
	},
	"LYD": {
		"money_format": "ل.د {{amount}}",
		"money_with_currency_format": "ل.د {{amount}} LYD"
	},
	"MAD": {
		"money_format": "{{amount}} dh",
		"money_with_currency_format": "Dh {{amount}} MAD"
	},
	"MDL": {
		"money_format": "{{amount}} MDL",
		"money_with_currency_format": "{{amount}} MDL"
	},
	"MGA": {
		"money_format": "Ar {{amount}}",
		"money_with_currency_format": "Ar {{amount}} MGA"
	},
	"MKD": {
		"money_format": "\u0434\u0435\u043d {{amount}}",
		"money_with_currency_format": "\u0434\u0435\u043d {{amount}} MKD"
	},
	"MMK": {
		"money_format": "K{{amount}}",
		"money_with_currency_format": ""
	},
	"MNT": {
		"money_format": "{{amount_no_decimals}} ₮",
		"money_with_currency_format": "{{amount_no_decimals}} MNT"
	},
	"MOP": {
		"money_format": "MOP${{amount}}",
		"money_with_currency_format": "MOP${{amount}}"
	},
	"MRO": {
		"money_format": "UM {{amount}}",
		"money_with_currency_format": "UM {{amount}} MRO"
	},
	"MUR": {
		"money_format": "Rs {{amount}}",
		"money_with_currency_format": "Rs {{amount}} MUR"
	},
	"MVR": {
		"money_format": "Rf{{amount}}",
		"money_with_currency_format": "Rf{{amount}} MVR"
	},
	"MWK": {
		"money_format": "MK {{amount}}",
		"money_with_currency_format": "MK {{amount}} MWK"
	},
	"MXN": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} MXN"
	},
	"MYR": {
		"money_format": "RM{{amount}}",
		"money_with_currency_format": "RM{{amount}} MYR"
	},
	"MZN": {
		"money_format": "{{amount}} Mt",
		"money_with_currency_format": "Mt {{amount}} MZN"
	},
	"NAD": {
		"money_format": "N${{amount}}",
		"money_with_currency_format": "N${{amount}} NAD"
	},
	"NGN": {
		"money_format": "₦{{amount}}",
		"money_with_currency_format": "₦{{amount}} NGN"
	},
	"NIO": {
		"money_format": "C${{amount}}",
		"money_with_currency_format": "C${{amount}} NIO"
	},
	"NOK": {
		"money_format": "kr {{amount_with_comma_separator}}",
		"money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
	},
	"NPR": {
		"money_format": "Rs{{amount}}",
		"money_with_currency_format": "Rs{{amount}} NPR"
	},
	"NZD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} NZD"
	},
	"OMR": {
		"money_format": "{{amount_with_comma_separator}} OMR",
		"money_with_currency_format": "{{amount_with_comma_separator}} OMR"
	},
	"PAB": {
		"money_format": "B/. {{amount}}",
		"money_with_currency_format": "B/. {{amount}} PAB"
	},
	"PEN": {
		"money_format": "S\/. {{amount}}",
		"money_with_currency_format": "S\/. {{amount}} PEN"
	},
	"PGK": {
		"money_format": "K {{amount}}",
		"money_with_currency_format": "K {{amount}} PGK"
	},
	"PHP": {
		"money_format": "₱{{amount}}",
		"money_with_currency_format": "₱{{amount}} PHP"
	},
	"PKR": {
		"money_format": "Rs.{{amount}}",
		"money_with_currency_format": "Rs.{{amount}} PKR"
	},
	"PLN": {
		"money_format": "{{amount_with_comma_separator}} zl",
		"money_with_currency_format": "{{amount_with_comma_separator}} PLN"
	},
	"PYG": {
		"money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
		"money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
	},
	"QAR": {
		"money_format": "QAR {{amount_with_comma_separator}}",
		"money_with_currency_format": "QAR {{amount_with_comma_separator}}"
	},
	"RON": {
		"money_format": "{{amount_with_comma_separator}} lei",
		"money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
	},
	"RSD": {
		"money_format": "{{amount}} RSD",
		"money_with_currency_format": "{{amount}} RSD"
	},
	"RUB": {
		"money_format": "₽ {{amount_with_comma_separator}}",
		"money_with_currency_format": "₽ {{amount_with_comma_separator}} RUB"
	},
	"RWF": {
		"money_format": "{{amount_no_decimals}} RF",
		"money_with_currency_format": "{{amount_no_decimals}} RWF"
	},
	"SAR": {
		"money_format": "{{amount}} SR",
		"money_with_currency_format": "{{amount}} SAR"
	},
	"SBD": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} SBD"
	},
	"SCR": {
		"money_format": "Rs {{amount}}",
		"money_with_currency_format": "Rs {{amount}} SCR"
	},
	"SDG": {
		"money_format": "£ {{amount}}",
		"money_with_currency_format": "£ {{amount}} SDG"
	},
	"SEK": {
		"money_format": "{{amount_with_comma_separator}} kr",
		"money_with_currency_format": "{{amount_with_comma_separator}} SEK"
	},
	"SGD": {
		"money_format": "S${{amount}}",
		"money_with_currency_format": "S${{amount}} SGD"
	},
	"SHP": {
		"money_format": "£ {{amount}}",
		"money_with_currency_format": "£ {{amount}} SHP"
	},
	"SLL": {
		"money_format": "Le {{amount}}",
		"money_with_currency_format": "Le {{amount}} SLL"
	},
	"SOS": {
		"money_format": "S {{amount}}",
		"money_with_currency_format": "S {{amount}} SOS"
	},
	"SRD": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} SRD"
	},
	"STD": {
		"money_format": "Db {{amount}}",
		"money_with_currency_format": "Db {{amount}} STD"
	},
	"SVC": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} SVC"
	},
	"SYP": {
		"money_format": "S£{{amount}}",
		"money_with_currency_format": "S£{{amount}} SYP"
	},
	"SZL": {
		"money_format": "L {{amount}}",
		"money_with_currency_format": "L {{amount}} SZL"
	},
	"THB": {
		"money_format": "{{amount}} ฿",
		"money_with_currency_format": "{{amount}} ฿ THB"
	},
	"TJS": {
		"money_format": "TJS {{amount}}",
		"money_with_currency_format": "TJS {{amount}} TJS"
	},
	"TMT": {
		"money_format": "m {{amount}}",
		"money_with_currency_format": "m {{amount}} TMT"
	},
	"TND": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} DT"
	},
	"TOP": {
		"money_format": "T$ {{amount}}",
		"money_with_currency_format": "T$ {{amount}} TOP"
	},
	"TRY": {
		"money_format": "{{amount}} TL",
		"money_with_currency_format": "{{amount}} TL"
	},
	"TTD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} TTD"
	},
	"TWD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} TWD"
	},
	"TZS": {
		"money_format": "{{amount}} TZS",
		"money_with_currency_format": "{{amount}} TZS"
	},
	"UAH": {
		"money_format": "\u20b4{{amount}}",
		"money_with_currency_format": "\u20b4{{amount}} UAH"
	},
	"UGX": {
		"money_format": "Ush {{amount_no_decimals}}",
		"money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
	},
	"USD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} USD"
	},
	"UYU": {
		"money_format": "${{amount_with_comma_separator}}",
		"money_with_currency_format": "${{amount_with_comma_separator}} UYU"
	},
	"UZS": {
		"money_format": "лв {{amount}}",
		"money_with_currency_format": "лв {{amount}} UZS"
	},
	"VEF": {
		"money_format": "Bs. {{amount_with_comma_separator}}",
		"money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
	},
	"VND": {
		"money_format": "{{amount_no_decimals_with_comma_separator}}₫",
		"money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
	},
	"VUV": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}}VT"
	},
	"WST": {
		"money_format": "WS$ {{amount}}",
		"money_with_currency_format": "WS$ {{amount}} WST"
	},
	"XAF": {
		"money_format": "FCFA{{amount}}",
		"money_with_currency_format": "FCFA{{amount}} XAF"
	},
	"XAG": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} XAG"
	},
	"XAU": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} XAU"
	},
	"XCD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "EC${{amount}}"
	},
	"XDR": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} XDR"
	},
	"XOF": {
		"money_format": "CFA{{amount}}",
		"money_with_currency_format": "CFA{{amount}} XOF"
	},
	"XPF": {
		"money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
		"money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
	},
	"YER": {
		"money_format": "﷼ {{amount}}",
		"money_with_currency_format": "﷼ {{amount}} YER"
	},
	"ZAR": {
		"money_format": "R {{amount}}",
		"money_with_currency_format": "R {{amount}} ZAR"
	},
	"ZMW": {
		"money_format": "K{{amount_no_decimals_with_comma_separator}}",
		"money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
	},
  	"VES": {
		"money_format": "Bs {{amount}}",
		"money_with_currency_format": "Bs {{amount}} VES"
	},
  	"ZMK": {
		"money_format": "ZK {{amount}}",
		"money_with_currency_format": "ZK {{amount}} ZMK"
	},
  	"ZMK": {
		"money_format": "ZK {{amount}}",
		"money_with_currency_format": "ZK {{amount}} ZMK"
	},
  	"SIT": {
		"money_format": "SIT {{amount}}",
		"money_with_currency_format": "SIT {{amount}}"
	},
  	"SKK": {
		"money_format": "Sk {{amount}}",
		"money_with_currency_format": "Sk {{amount}} SKK"
	},
  	"CNH": {
		"money_format": "¥ {{amount}}",
		"money_with_currency_format": "¥ {{amount}} CNH"
	},
  	"MRU": {
		"money_format": "UM {{amount}}",
		"money_with_currency_format": "UM {{amount}} MRU"
	},
  	"STN": {
		"money_format": "Db {{amount}}",
		"money_with_currency_format": "Db {{amount}} STN"
	},
  	"LBD": {
		"money_format": "L$ {{amount}}",
		"money_with_currency_format": "L$ {{amount}} LBD"
	},
  	"BBD": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "L$ {{amount}} BBD"
	},
  	"MTL": {
		"money_format": "Lm {{amount}}",
		"money_with_currency_format": "Lm {{amount}} MTL"
	},
  	"ZWD": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} ZWD"
	},
  	"TMM": {
		"money_format": "T {{amount}}",
		"money_with_currency_format": "T {{amount}} TMM"
	},
  	"EEK": {
		"money_format": "kr {{amount}}",
		"money_with_currency_format": "kr {{amount}} EEK"
	},
  	"ZMK": {
		"money_format": "ZK {{amount}}",
		"money_with_currency_format": "ZK {{amount}} ZMK"
	},
  	"XBT": {
		"money_format": "BTC {{amount}}",
		"money_with_currency_format": "BTC {{amount}} XBT"
	},
  	"NTD": {
		"money_format": "NT$ {{amount}}",
		"money_with_currency_format": "NT$ {{amount}} NTD"
	},
  	"BYR": {
		"money_format": "p {{amount}}",
		"money_with_currency_format": "p {{amount}} BYR"
	}
};

pb_Currency_global.formatMoney = function(cents, format, showDecimals = true , roundTo = null) {
  
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    	var fullAmount = dollars + cents;
    return fullAmount;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, ',', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 2, ',', '.');
      break;
  }
  if(showDecimals === false) {
    value = value.replace(/\.\d*/, '');
  }
  if(roundTo !== null && showDecimals === true) {
    if(value.search(".") != '-1') {
      value = value.substr(0,value.length-2)+""+roundTo;
    }
  }
  return formatString.replace(placeholderRegex, value);
};

pb_Currency_global.currentCurrency = '';

pb_Currency_global.convertAll = function(oldCurrency, newCurrency, selector, format) {
  jQuery(selector || 'span.money').each(function() {
    let checkNewCurrency = jQuery(this).attr('data-currency-'+newCurrency);
    let checkOldCurrency = jQuery(this).attr('data-currency-'+oldCurrency);
    //add decimals if not there
    let hasDecimal = jQuery(this).html().includes(".");
    if(!hasDecimal) {
    	let getAmountHtml = jQuery(this).html();
      	let getPrice = getAmountHtml.replace(/.*?(\d+)[^\d]*$/,'$1');
        let newFormattedAmountWithDecimal = getAmountHtml.replace(getPrice, getPrice+".00");
      	jQuery(this).html(newFormattedAmountWithDecimal);
    }
    
    //define old currency if not there
    if (checkOldCurrency == undefined) {
      jQuery(this).attr('data-currency-'+oldCurrency, jQuery(this).html());
    }
    // If the amount has already been converted, we leave it alone.
    if (jQuery(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if (checkNewCurrency != undefined) {
      jQuery(this).html(checkNewCurrency);
    }
    else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = pb_Currency_global.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
      var newFormat = pb_Currency_global.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = pb_Currency_global.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10)*100, oldCurrency, newCurrency);
      }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = pb_Currency_global.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10)/10, oldCurrency, newCurrency);
      }
      else { 
        cents = pb_Currency_global.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
      }
      var newFormattedAmount = pb_Currency_global.formatMoney(cents, newFormat);
      jQuery(this).attr('data-currency-'+newCurrency, newFormattedAmount);
      jQuery(this).html(newFormattedAmount);
    }
    // We record the new currency locally.
    jQuery(this).attr('data-currency', newCurrency);
    
    //checkdecimals
    if(currencyConfig.showDecimal === 0) {
    	let currencyWithoutDecimal = parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10);
      	let activatedCurrency = jQuery(this).attr('data-currency');
      	newFormat = pb_Currency_global.moneyFormats[activatedCurrency][format || pb_Currency_global.format] || '{{amount}}';
      	let formattedAmountWIthoutDecimal = pb_Currency_global.formatMoney(currencyWithoutDecimal, newFormat, false);
        
      	if(jQuery(this).next(".pb_currency_duplicate").length == 0) {
			jQuery(this).after(`<span class="pb_currency_duplicate"></span>`);
        }
      	jQuery(this).next(".pb_currency_duplicate").html(formattedAmountWIthoutDecimal);
      	jQuery(this).hide();
    }
    else if(currencyConfig.showDecimal === 1 && currencyConfig.roundingDecimals === 1) {
      	let moneyForRounding = parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10);
      	let activatedCurrency = jQuery(this).attr('data-currency');
      	newFormat = pb_Currency_global.moneyFormats[activatedCurrency][format || pb_Currency_global.format] || '{{amount}}';
      	let formattedAmountRoundTo = pb_Currency_global.formatMoney(moneyForRounding, newFormat, true, currencyConfig.roundTo);
      	
      	if(jQuery(this).next(".pb_currency_duplicate").length == 0) {
			jQuery(this).after(`<span class="pb_currency_duplicate"></span>`);
        }
      	jQuery(this).next(".pb_currency_duplicate").html(formattedAmountRoundTo);
      	jQuery(this).hide();
    }
  });
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
  cartInit();
}
   
}

function cartInit() {
	let checkSelector = jQuery("form[action^='/cart'] .PB_currency_message");
  	let checkAjaxSelector = jQuery(".ajaxcart .PB_currency_message");
  	let checkAjaxifySelector = jQuery("#ajaxifyCart .PB_currency_message");
    let checkIfCartExists = jQuery("form[action^='/cart']");
    let shop = Shopify.shop;
    if(currencyConfig.currencyNotification === 1 && pb_shopCurrency != pb_Currency_global.currentCurrency) {
      	let message = currencyConfig.message;
      	let pathName = window.location.pathname;
      	let indexUrl = pathName.split("/").pop();
      	message = message.replace(/PB.shopName/gi, shop).replace(/PB.currency/gi, pb_shopCurrency).replace(/PB.selectedCurrency/gi, pb_Currency_global.currentCurrency).replace(/\(/g, '').replace(/\)/g, '');

        if(indexUrl === "cart") {
			if(checkSelector.length == 0 && checkIfCartExists.length > 0) {
                jQuery("form[action^='/cart']").prepend('<div class="PB_currency_message"></div>');
            }
        }
        if(checkAjaxSelector.length == 0) {
			jQuery(".ajaxcart .ajaxcart__inner").prepend('<div class="PB_currency_message"></div>');
        }
        if(checkAjaxifySelector.length == 0) {
			jQuery("#ajaxifyCart form[action^='/cart']").append('<div class="PB_currency_message"></div>');
        }
        jQuery(".PB_currency_message").each(function() {
          jQuery(this).text(message);
          jQuery(this).css({
            "background" : currencyConfig.messageBgColor,
            "color" : currencyConfig.messageTextColor
          });
        });
      	jQuery(".PB_currency_message").show();
    }else {
    	jQuery(".PB_currency_message").hide();
    }
}

/*function cartSubTotal() {
  let selctor = subTotal();
  if(selctor.length != 0) {
    for(var i = 0; i < selctor.length; i++) {
      let newSelector = jQuery(selctor[i]);
      let findProducts = newSelector.closest("form[action^='/cart']").find(".pb_currency_duplicate");
      let totalAmount = 0;
      findProducts.each(function() { 
      	let amountWithFormat = jQuery(this).html();
        console.log(parseFloat(amountWithFormat));
      });
    }
  }
}*/

/*function subTotal() {
  let selectors = ['.cart-subtotal .pb_currency_duplicate','.cart__subtotal .pb_currency_duplicate','.ajaxcart__subtotal .pb_currency_duplicate', '.cart-total .pb_currency_duplicate'];
  let matched = [];
  for (var i = 0; i < selectors.length; i++) {
    var subTotalSelectors = document.querySelectorAll(selectors[i]);
    for (var j = 0; j < subTotalSelectors.length; j++) {
      var subTotalSelector = subTotalSelectors[j];
      if (subTotalSelector) {
        matched.push(subTotalSelector);
      }
    }
  }
  return matched;
}*/

function hideMoreThanOne() {
  let visibleWrapper = jQuery(".Pb_currency_wrapper:visible").length;
  if(visibleWrapper > 1) {
    for(var i = 1; i < visibleWrapper; i ++) {
      let selector = jQuery(".Pb_currency_wrapper:visible")[i];
      jQuery(selector).addClass("pb_hidden");
    }
    jQuery(".Pb_currency_wrapper ~ .Pb_currency_wrapper").remove();
  }
}

function pbAsyncCurrency() {
  let oldCurrency = pb_defaultCurrency;
  pb_Currency_global.convertAll(oldCurrency, jQuery('[name=PB_Currency_select]').val(), 'span.money' , pb_Currency_global.format);
}